import colors from './partials/colors';
import constants from './partials/constants';
import { fonts } from './partials/fonts';
import zIndex from './partials/zIndex';
import device from './partials/device';
import storage from '../../app/api/storage';
import { mixin } from './partials/mixin';

function theme(themeName) {
  const defaultTheme = storage.read('theme')?.value;
  const themeColors = colors(themeName || defaultTheme);

  return {
    name: themeName,
    colors: themeColors,
    device,
    constants,
    fontset: fonts,
    zIndex,
    mixin,
  };
}

export default theme;
